<script lang="ts">
  import Router from "svelte-spa-router";
  import { Toaster } from "$components";
  import "../../../node_modules/easymde/dist/easymde.min.css";
  import "../../globals.css";
  import Store from "./views/Store/Index.svelte";
  import FindSite from "./views/Store/FindSite.svelte";
  import MyPagesLoginRequired from "./MyPagesLoginRequired.svelte";
  import { svelte5Comp } from "$shared/lib/router";
  import wrap from "svelte-spa-router/wrap";
  import PublicProfileView from "./views/PublicProfile.svelte";

  const routes = {
    "/store/": svelte5Comp(FindSite),
    "/store/:site_id": svelte5Comp(Store),
    "/public/profile/:debtorId/:token": wrap({
      component: svelte5Comp(PublicProfileView),
    }),
    "*": MyPagesLoginRequired,
  };
</script>

<main class="main-content">
  <Router {routes} />
  <Toaster />
</main>
<style lang="postcss">
  .main-content {
    container-type: inline-size;
  }
</style>
